// PATH: src/api/authEvents.ts — signal « session invalide » émis par la couche
// HTTP et reçu par le contexte d'authentification.
//
// Pourquoi ce détour : l'intercepteur axios (apiClients) découvre l'expiration
// d'une session au 401 d'une requête quelconque, mais il vit HORS de React et
// ne peut pas toucher au state du contexte. Sans ce signal, le contexte
// resterait « authenticated » après l'expiration, et /login — se croyant déjà
// connecté — renverrait vers l'application, qui reprendrait un 401 : boucle de
// redirection infinie.
//
// Volontairement limité à l'onglet courant. La synchronisation entre onglets
// (BroadcastChannel, cf. tc_tilmicode_ui/src/lib/authSync.ts) est un autre
// sujet, non nécessaire ici.
type Listener = () => void;

const listeners = new Set<Listener>();

/** S'abonne au signal. Retourne la fonction de désabonnement. */
export const onUnauthorized = (fn: Listener): (() => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};

/** Émis par l'intercepteur HTTP quand le serveur répond 401. */
export const emitUnauthorized = (): void => {
  listeners.forEach((fn) => fn());
};
